function cov_5gqxxygwa() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InfoFilled.tsx";
  var hash = "99a0ed736a03cd0e9ffd3839b410eb66959df989";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/InfoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "99a0ed736a03cd0e9ffd3839b410eb66959df989"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_5gqxxygwa = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_5gqxxygwa();
var Icon = (cov_5gqxxygwa().s[0]++, {
  name: 'info-filled',
  svg: "<path d=\"M20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12ZM9.25 8.40039C9.25 9.11401 9.52182 9.76415 9.96757 10.2529C9.52612 10.6637 9.25 11.2498 9.25 11.9004V15.9004C9.25 17.143 10.2574 18.1504 11.5 18.1504H12.5C13.7426 18.1504 14.75 17.143 14.75 15.9004V11.9004C14.75 11.2498 14.4739 10.6637 14.0324 10.2529C14.4782 9.76415 14.75 9.11401 14.75 8.40039C14.75 6.88161 13.5188 5.65039 12 5.65039C10.4812 5.65039 9.25 6.88161 9.25 8.40039Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2.5\"/>"
});
export default Icon;